import { Box } from "@mui/material";

export default function Content({children}: {children: React.ReactNode}) {
  return (
    <Box sx={styles.content}>
      {children}
    </Box>
  )
};

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    p: 4,
    mb: 3,
    border: 'solid #eeeeee 0.6px',
    borderRadius: 7
  },
}